import { render, staticRenderFns } from "./BuyerAds.vue?vue&type=template&id=71c7b813&"
import script from "./BuyerAds.vue?vue&type=script&lang=js&"
export * from "./BuyerAds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports